import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'smatchy-offline-container',
  templateUrl: './offline-container.component.html',
  imports: [IonicModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfflineContainerComponent {
  loading = signal(false);

  /**
   * The Try again button.
   *
   * It used to reload only when navigator.onLine was true. But this screen is
   * shown precisely when navigator.onLine is false, so pressing it did nothing
   * at all, silently, with its own spinner commented out. And navigator.onLine
   * can stay false after connectivity returns if the 'online' event is missed,
   * which left people closing the app to get out.
   *
   * Reloading unconditionally is safe: outside of LIVE development builds,
   * capacitor.config removes server.url, so the app serves its bundled files
   * and a reload needs no network. If still offline, app.component presents
   * this screen again on start, which is the honest answer to the button.
   */
  refresh() {
    this.loading.set(true);
    this.reload();
  }

  /** Separate so a test can observe it; jsdom will not let window.location.reload be replaced. */
  protected reload(): void {
    window.location.reload();
  }
}
